import React from "react";
import { Box, Skeleton } from "@mui/material";

const CustomSkelton = () => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ width: 'auto' }}>
                <Skeleton />
                <Skeleton animation="wave" />
            </Box>
            <Box sx={{ width: '80%' }}>
                <Skeleton animation="wave" />
            </Box>
            <Box sx={{ width: '60%' }}>
                <Skeleton animation="wave" />
            </Box>
            <Box sx={{ width: '40%' }}>
                <Skeleton animation="wave" />
            </Box>
            <Box sx={{ width: '50%' }}>
                <Skeleton animation="wave" />
            </Box>
        </Box>
    );
}

export default CustomSkelton;
